import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { Command } from 'cmdk';

import { cn } from 'styles';

type CommandMenuListProps = ComponentPropsWithoutRef<typeof Command.List>;

export const COMMAND_LIST_HEIGHT_CSS_VAR = '--cmdk-list-height';

export const CommandMenuList = forwardRef<ElementRef<typeof Command.List>, CommandMenuListProps>(
  ({ className, ...props }, ref) => (
    <Command.List
      ref={ref}
      className={cn('max-h-[300px] overflow-y-auto overflow-x-hidden', className)}
      {...props}
    />
  ),
);

CommandMenuList.displayName = Command.List.displayName;
